// export enum ChatUserType {
//     User,
//     Consultant
// }
export interface MotivationPartialData  {
    id: string;
    name: string;
    shortDescription: string;
    imageUrl: string;
    color: string;
}

export interface MotivationDetailsItem  {
    name: string;
    longDescription: string;
    imageURL: string;
    color: string;
}

export class TextPartData{
    text: string;
    isHeader: boolean;
  
    constructor(){
      this.text = "";
      this.isHeader = false;
    }
  }

export interface MotivationFullDetails {
    id: string;
    name: string;
    shortDescription: string;
    longDescription?: string;
    longDescriptionPlural?: string;
    additionalData?: string;
    imageUrl: string;
    color: string;
    videoUrl: string
    tailResolution?: string;
    gapFactor?:number;
}

export interface UserMotivationDetails {
    id: string;
    name: string;
    shortDescription: string;
    imageUrl: string;
    color: string;
    gapFactor: number;
    trendData: number;
    isGapDataRelevant : boolean;
    isTrendDataExists : boolean;
    isTrendDataRelevant : boolean;
}

export interface ScoreDetails {
    userId: string;
    score: number;
    trend: number;
    isScoreDataExistsAndRelevant: boolean;
    isTrendDataExistsAndRelevant: boolean;
}

export interface InsightTypeData{
    id : string;
    type: number;
    internalOrder: number;
    name: string;
    text: string;
}

export interface MotivationInsightData{
    id: string;
    motivationId: string;
    insightId: string;
    type: number;
    shortDescription: string;
    longDescription: string;
}

export interface InsightAggregationData{
    insightType: InsightTypeData;
    insights: MotivationInsightData[];
}


export interface Insights {
    insights: Insight[];
}
export interface Insight {
    title: string;
    itemsList: InsightSubItem[];
}
export interface InsightSubItem {

    motivationId: string;
    shortDescription: string;
    longDescription: string;
    color: string;
}

export interface CultureDetails{
    id: string;
    name: string;
    header: string;
    description : string;
    imageUrl: string;
    drivers: string[];
}